module.exports = "/public/images/b62bbb7830391f4cc1265bd13f7937a9.svg";